// // src/app.js
// // console.log('hello world');
const $ = jQuery

// hash-based redirects. The #fragment never reaches the server, so these can't
// live in the Redirection plugin. Keys are the page a visitor *lands on* after
// any server-side redirect — the browser carries the hash across a 301, so e.g.
// /what-we-do/storytelling-and-communications/#calendar arrives here as
// /speaking/#calendar via the Redirection plugin's /speaking/ rule.
const hashRedirects = {
	// from /what-we-do/storytelling-and-communications/ (301s to /speaking/)
	'/speaking/#calendar': '/events/',
	// from /what-we-do/research-and-practice/ (301s to /reports-and-publications/)
	'/reports-and-publications/#measurement-inventory': '/social-connection-measurement-tools-inventory/',
	'/reports-and-publications/#catalog': '/resources/social-connection-intervention-catalog/',
	'/reports-and-publications/#partners': '/case-studies/',
}

const hashRedirectTarget = hashRedirects[location.pathname.replace(/\/?$/, '/') + location.hash]
if (hashRedirectTarget) location.replace(hashRedirectTarget)

// calculate viewport width
const style = document.createElement('style');
style.id = 'viewport-width';
const calculateViewportWidth = () => {
  const width = document.documentElement.clientWidth;
  style.innerHTML = `:root { --viewport-width: ${width}px; }`;
};
document.head.appendChild(style);
calculateViewportWidth();

document.addEventListener('DOMContentLoaded', () => {
  const ob =  new ResizeObserver(calculateViewportWidth);
  ob.observe(document.documentElement);
});

const initGalleryBlocks = () => {
	const $galleries = $('.wp-block-gallery');
	$galleries.each((i, gallery) => {
		const $gallery = $(gallery)
		$gallery.addClass('alignwide')
		$gallery.wrapInner('<div class="swiper-wrapper" />')
		$gallery.wrapInner('<div class="swiper" />')
		$gallery.find('.wp-block-image').addClass('swiper-slide')

		const $swiper = $gallery.find('.swiper')
		$swiper.append(`
			<div class="swiper-button-prev">
				<svg width="23" height="19" viewBox="0 0 23 19" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M23 9.5L2 9.5M2 9.5L10.6471 18M2 9.5L10.6471 0.999999" stroke="black" stroke-width="2"/>
				</svg>
			</div>
		`)
		$swiper.append(`
			<div class="swiper-button-next">
				<svg width="23" height="19" viewBox="0 0 23 19" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M0 9.5H21M21 9.5L12.3529 1M21 9.5L12.3529 18" stroke="black" stroke-width="2"/>
				</svg>
			</div>
		`)

		const swiper = new Swiper($swiper[0], {
			spaceBetween: 30,
			grabCursor: true,
			slidesPerView: 'auto',
			// loop: true,
			navigation: {
				nextEl: $swiper.find('.swiper-button-next')[0],
				prevEl: $swiper.find('.swiper-button-prev')[0],
			},
		})
	})
}

const initShareWidgets = () => {
	const $widgets = $('.share-widget')

	$widgets.each((i, widget) => {
		const $widget = $(widget)
		const $toggle = $widget.find('.share-widget__toggle')

		$toggle.on('click', (e) => {
			e.stopPropagation()
			const isOpen = $widget.toggleClass('is-open').hasClass('is-open')
			$toggle.attr('aria-expanded', isOpen ? 'true' : 'false')
		})
	})

	// tapping/clicking outside an open widget closes it
	$(document).on('click', (e) => {
		$widgets.filter('.is-open').each((i, widget) => {
			const $widget = $(widget)
			if ($widget.is(e.target) || $widget.has(e.target).length) return
			$widget.removeClass('is-open')
			$widget.find('.share-widget__toggle').attr('aria-expanded', 'false')
		})
	})

	$(document).on('keydown', (e) => {
		if (e.key !== 'Escape') return
		$widgets.removeClass('is-open')
		$widgets.find('.share-widget__toggle').attr('aria-expanded', 'false')
	})
}

$(document).ready(() => {
	initGalleryBlocks();
	initShareWidgets();
})
